export const Connect = ({ expand, expandableRef2 }) => {
    return <section className="connect expandable" onClick={expand} ref={expandableRef2}>
        <h1>connect</h1>
        <div className="expandable-data">
        <div className="header">
                <p>gaya shayo</p>
                <p>connect</p>
                <p>graphic designer</p>
            </div>
        </div>
    </section>
}